import React, { useEffect,  useRef, useState } from "react";

import { Row, Col, Offcanvas, Button } from "react-bootstrap";

import { format } from "date-fns";

import ColourFilterBox from "../../../../components/FilterBox/ColourFilter/ColourFilter";
import ColourTable from "../../../../components/Tables/ColourTable";
import { useDispatch, useSelector } from "react-redux";
import Cookies from "js-cookie";
import { FiMenu } from "react-icons/fi";
import { MdOutlineSystemUpdateAlt } from "react-icons/md";
import {
  ColourFilter,
  PartyVsItem,
  PartyVsItemFun,
} from "../../../../Redux/Slice/Colour/InwardAnylysis/InwardAnylysis";
import { Loader } from "../../../../components/Loader/Loader";
import ColourParentChild from "../../../../components/Tables/ColourParentChild";
import Calendar from "react-calendar";
import { useTheme } from "../../../../Themecontext/Themecontext";
import ColorCalenderCss from "../../../../components/Calendar/ColorCalenderCss";

export const Party_ItemAnalysis = () => {
  const dispatch = useDispatch();

  const { Colourdata, DataMain } = useSelector((state) => state.ClientLogin);
  const { ColourfilterData, PartyVsItemdata } = useSelector(
    (state) => state.InwardAnylysisSlice,
  );

  const iscolour = Colourdata?.data?.find(
    (el) => el.ExeName === "NEWCOLOURCHEMICL",
  );
  const iscolourDark = Colourdata?.data?.find(
    (el) => el.ExeName === "NEWCOLOURCHEMICLDARK",
  );
  const { theme } = useTheme();
  const isdark = theme;
  const Firm = Cookies.get("Firm");
  const FinancialYear = Cookies.get("FinancialYear");

  const [showFilter, setShowFilter] = useState(false);
  const [dateRange, setDateRange] = useState([
    {
      startDate: null,
      endDate: null,
      key: "selection",
    },
  ]);

  function parseRangeToDates(rangeString) {
    if (!rangeString) return { startDate: null, endDate: null };

    const [startStr, endStr] = rangeString.split(" - ");

    const parseDDMMYYYY = (s) => {
      const [day, month, year] = s.split("/").map(Number);
      return new Date(year, month - 1, day);
    };

    return {
      startDate: parseDDMMYYYY(startStr),
      endDate: parseDDMMYYYY(endStr),
    };
  }

  const isFYDateSet = useRef(false);

  useEffect(() => {
    if (!DataMain || !FinancialYear) return;
    if (isFYDateSet.current) return;

    let matchedYear = null;

    DataMain?.AC_Year_List?.forEach((el) => {
      if (el.AcYearID === Number(FinancialYear)) {
        matchedYear = el.AcYear;
      }
    });

    if (matchedYear) {
      const { startDate, endDate } = parseRangeToDates(matchedYear);

      setDateRange([
        {
          startDate,
          endDate,
          key: "selection",
        },
      ]);

      isFYDateSet.current = true;
    }
  }, [DataMain, FinancialYear]);

  const startDate = dateRange?.[0]?.startDate;
  const endDate = dateRange?.[0]?.endDate;

  const [showDatePicker, setShowDatePicker] = useState(false);
  const [activeTable, setActiveTable] = useState("PARTYWISE");

  const accountNameList =
    ColourfilterData?.InwardAc?.map((item) => ({
      label: item.Acname,
      value: item.Acid,
    })) || [];

  const [filter, setFilter] = useState({
    accountName: [],
  });

  const [search, setSearch] = useState({
    accountName: "",
  });
  useEffect(() => {
    if (!startDate || !endDate) return;

    dispatch(ColourFilter());

    dispatch(
      PartyVsItem({
        FirmIDs: Firm,
        AcYearIDs: FinancialYear,
        StartDate: format(startDate, "yyyy-MM-dd"),
        EndDate: format(endDate, "yyyy-MM-dd"),
      }),
    );
  }, [startDate, endDate, Firm, FinancialYear, dispatch]);

  const TableChartColumns = [
    {
      label: "Sr. No.",
      key: "srNumber",
      align: "center",
      colors: isdark === "light" ? "#000" : "#fff",
    },
    {
      label: "Item Name",
      key: "ItemName",
      align: "left",
      colors: isdark === "light" ? "#000" : "#fff",
    },
    { label: "Total Qty", key: "TotalInwQty", align: "right", format: "true" },
    { label: "Apr", key: "AprilQty", align: "right", format: "true" },
    { label: "May", key: "MayQty", align: "right", format: "true" },
    { label: "Jun", key: "JunQty", align: "right", format: "true" },
    { label: "Jul", key: "JulyQty", align: "right", format: "true" },
    { label: "Aug", key: "AugQty", align: "right", format: "true" },
    { label: "Sep", key: "SepQty", align: "right", format: "true" },
    { label: "Oct", key: "OctQty", align: "right", format: "true" },
    { label: "Nov", key: "NovQty", align: "right", format: "true" },
    { label: "Dec", key: "DecQty", align: "right", format: "true" },
    { label: "Jan", key: "JanQty", align: "right", format: "true" },
    { label: "Feb", key: "FebQty", align: "right", format: "true" },
    { label: "Mar", key: "MarchQty", align: "right", format: "true" },
  ];

  const TableChartRow = (PartyVsItemdata?.ItemWise || []).map((row) => ({
    ItemName: row?.ItemName ?? "",

    // Month-wise Quantity
    AprilQty: row?.AprilQty ?? 0,
    MayQty: row?.MayQty ?? 0,
    JunQty: row?.JunQty ?? 0,
    JulyQty: row?.JulyQty ?? 0,
    AugQty: row?.AugQty ?? 0,
    SepQty: row?.SepQty ?? 0,
    OctQty: row?.OctQty ?? 0,
    NovQty: row?.NovQty ?? 0,
    DecQty: row?.DecQty ?? 0,
    JanQty: row?.JanQty ?? 0,
    FebQty: row?.FebQty ?? 0,
    MarchQty: row?.MarchQty ?? 0,

    // Total
    TotalInwQty: row?.TotalInwQty ?? 0,
  }));

  const TableChartColumns1 = [
    {
      label: "Sr. No.",
      key: "srNumber",
      align: "center",
      colors: isdark === "light" ? "#000" : "#fff",
    },
    {
      label: "Party Name",
      key: "PartyName",
      align: "left",
      colors: isdark === "light" ? "#000" : "#fff",
    },
    { label: "Total Amt", key: "NetAmount", align: "right", format: "true" },
    { label: "Apr", key: "AprilAmt", align: "right", format: "true" },
    { label: "May", key: "MayAmt", align: "right", format: "true" },
    { label: "Jun", key: "JunAmt", align: "right", format: "true" },
    { label: "Jul", key: "JulyAmt", align: "right", format: "true" },
    { label: "Aug", key: "AugAmt", align: "right", format: "true" },
    { label: "Sep", key: "SepAmt", align: "right", format: "true" },
    { label: "Oct", key: "OctAmt", align: "right", format: "true" },
    { label: "Nov", key: "NovAmt", align: "right", format: "true" },
    { label: "Dec", key: "DecAmt", align: "right", format: "true" },
    { label: "Jan", key: "JanAmt", align: "right", format: "true" },
    { label: "Feb", key: "FebAmt", align: "right", format: "true" },
    { label: "Mar", key: "MarchAmt", align: "right", format: "true" },
  ];

  const TableChartRow1 = (PartyVsItemdata?.PartiWise || []).map((row) => ({
    PartyName: row?.AcName ?? "",
    AprilAmt: row?.AprilAmt ?? 0,
    MayAmt: row?.MayAmt ?? 0,
    JunAmt: row?.JunAmt ?? 0,
    JulyAmt: row?.JulyAmt ?? 0,
    AugAmt: row?.AugAmt ?? 0,
    SepAmt: row?.SepAmt ?? 0,
    OctAmt: row?.OctAmt ?? 0,
    NovAmt: row?.NovAmt ?? 0,
    DecAmt: row?.DecAmt ?? 0,
    JanAmt: row?.JanAmt ?? 0,
    FebAmt: row?.FebAmt ?? 0,
    MarchAmt: row?.MarchAmt ?? 0,

    NetAmount: row?.NetAmount ?? 0,
  }));

  // --- Table Configuration ---
  const columns = [
    {
      label: "Item Name",
      key: "ItemName",
      align: "left",
      colors: isdark === "light" ? "#000" : "#fff",
    },
    {
      label: "Month Name",
      key: "MonthName",
      align: "left",
      colors: isdark === "light" ? "#000" : "#fff",
    },
    { label: "Min Rate", key: "MinInwRate", align: "right", format: "true" },
    { label: "Max Rate", key: "MaxInwRate", align: "right", format: "true" },
    {
      label: "Different Rate",
      key: "DiffRate",
      align: "right",
      format: "true",
    },
  ];

  const rows = (PartyVsItemdata?.MinMaxRate || []).map((row) => ({
    ItemName: row?.ItemName ?? "",
    MonthName: row?.MonthName ?? "",
    MinInwRate: row?.MinRate ?? 0,
    MaxInwRate: row?.MaxRate ?? 0,
    DiffRate: row?.DiffRate ?? 0,
  }));

  if (!ColourfilterData) {
    return (
      <div className="flex justify-center items-center h-screen">
        <Loader />
      </div>
    );
  }

  if (!PartyVsItemdata || PartyVsItemdata === "no") {
    return (
      <div className="flex justify-center items-center h-screen">
        <Loader />
      </div>
    );
  }

  const toggleItem = (type, item) => {
    setFilter((prev) => {
      const selected = prev[type];

      const updatedSelected = selected.includes(item.value)
        ? selected.filter((i) => i !== item.value)
        : [...selected, item.value];

      if (type === "accountName") {
        if (!startDate || !endDate) return prev;
        dispatch(PartyVsItemFun());

        dispatch(
          PartyVsItem({
            FirmIDs: Firm,
            AcYearIDs: FinancialYear,
            AcIDs: updatedSelected.join(","),
            StartDate: format(startDate, "yyyy-MM-dd"),
            EndDate: format(endDate, "yyyy-MM-dd"),
          }),
        );
      }

      return {
        ...prev,
        [type]: updatedSelected,
      };
    });
  };

  const selectAll = (type, items) => {
    const allIds = items.map((i) => i.value);
    setFilter((prev) => ({
      ...prev,
      [type]: prev[type].length === items.length ? [] : allIds,
    }));
  };

  const handleSearch = (type, value) => {
    setSearch((prev) => ({
      ...prev,
      [type]: value,
    }));
  };

  if (!ColourfilterData) {
    return (
      <div className="flex justify-center items-center h-screen">
        <Loader />
      </div>
    );
  }

  if (!PartyVsItemdata || PartyVsItemdata === "no") {
    return (
      <div className="flex justify-center items-center h-screen">
        <Loader />
      </div>
    );
  }

  return (
    <div
      style={{
        background:
          isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour4,
        minHeight: "100vh",
        padding: "16px",
      }}
    >
      <Row>
        {/* 🔷 Mobile Filter Button */}
        <div className="d-lg-none text-end mb-2">
          <Button
            onClick={() => setShowFilter(true)}
            style={{
              background:
                isdark === "light" ? iscolour?.Colour6 : iscolourDark?.Colour7,
              border: "none",
            }}
          >
            <FiMenu />
          </Button>
        </div>

        {/* 🔷 Desktop Filter */}
        <Col xl={3} lg={4} className="d-none d-lg-block">
          <div
            style={{ display: "flex", flexDirection: "column", gap: "20px" }}
          >
            {/* Date */}
            <div>
              <div
                style={{
                  backgroundColor:
                    isdark === "light"
                      ? iscolour?.Colour6
                      : iscolourDark?.Colour7,
                  padding: "13px 20px",
                  borderRadius: "12px 12px 0px 0px",
                }}
              >
                <h3
                  style={{
                    fontWeight: "700",
                    fontSize: "18px",
                    margin: 0,
                    color:
                      isdark === "light"
                        ? iscolour?.Colour1
                        : iscolourDark?.Colour12,
                    alignItems: "center",
                    display: "flex",
                  }}
                >
                  {" "}
                  Date Range
                </h3>
              </div>
              <div
                style={{
                  border: `2px solid ${isdark === "light" ? iscolour?.Colour4 : iscolourDark?.Colour6}`,
                  padding: "15px",
                  background:
                    isdark === "light"
                      ? iscolour?.Colour1
                      : iscolourDark?.Colour3,
                  borderRadius: "0px 0px 12px 12px",
                }}
              >
                <div
                  onClick={() => setShowDatePicker(true)}
                  style={{
                    marginTop: "8px",
                    padding: "10px",
                    border: `2px solid ${isdark === "light" ? iscolour?.Colour4 : iscolourDark?.Colour6}`,
                    borderRadius: "10px",
                    cursor: "pointer",
                    textAlign: "center",
                    color: isdark === "light" ? "#000" : "#fff",
                  }}
                >
                  {dateRange?.[0]?.startDate && dateRange?.[0]?.endDate
                    ? `${format(dateRange[0].startDate, "dd-MM-yyyy")} - ${format(dateRange[0].endDate, "dd-MM-yyyy")}`
                    : "Select Date Range"}
                </div>
              </div>
            </div>

            {/* Filters */}
            <ColourFilterBox
              title="Account Name"
              items={accountNameList}
              search={search.accountName}
              setSearch={(val) => handleSearch("accountName", val)}
              selectedItems={filter.accountName}
              toggleItem={(item) => toggleItem("accountName", item)}
              selectAll={() => selectAll("accountName", accountNameList)}
            />
          </div>
        </Col>

        {/* 🔷 Offcanvas */}
        <Offcanvas show={showFilter} onHide={() => setShowFilter(false)}
          style={{
            background:
              isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour4,
          }}
        >
          <Offcanvas.Header closeButton
            closeVariant={isdark === "dark" ? "white" : undefined}
            style={{ color: isdark === "light" ? "#000" : "#FFF", }} >
            <Offcanvas.Title>Filters</Offcanvas.Title>
          </Offcanvas.Header>
          <Offcanvas.Body>
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                gap: "20px",
              }}
            >

              <div>
                <div
                  style={{
                    backgroundColor:
                      isdark === "light"
                        ? iscolour?.Colour6
                        : iscolourDark?.Colour7,
                    padding: "13px 20px",
                    borderRadius: "12px 12px 0px 0px",
                  }}
                >
                  <h3
                    style={{
                      fontWeight: "700",
                      fontSize: "18px",
                      margin: 0,
                      color:
                        isdark === "light"
                          ? iscolour?.Colour1
                          : iscolourDark?.Colour12,
                      alignItems: "center",
                      display: "flex",
                    }}
                  >
                    {" "}
                    Date Range
                  </h3>
                </div>
                <div
                  style={{
                    border: `2px solid ${isdark === "light" ? iscolour?.Colour4 : iscolourDark?.Colour6}`,
                    padding: "15px",
                    background:
                      isdark === "light"
                        ? iscolour?.Colour1
                        : iscolourDark?.Colour3,
                    borderRadius: "0px 0px 12px 12px",
                  }}
                >
                  <div
                    onClick={() => setShowDatePicker(true)}
                    style={{
                      marginTop: "8px",
                      padding: "10px",
                      border: `2px solid ${isdark === "light" ? iscolour?.Colour4 : iscolourDark?.Colour6}`,
                      borderRadius: "10px",
                      cursor: "pointer",
                      textAlign: "center",
                      color: isdark === "light" ? "#000" : "#fff",
                    }}
                  >
                    {dateRange?.[0]?.startDate && dateRange?.[0]?.endDate
                      ? `${format(dateRange[0].startDate, "dd-MM-yyyy")} - ${format(dateRange[0].endDate, "dd-MM-yyyy")}`
                      : "Select Date Range"}
                  </div>
                </div>
              </div>

              <ColourFilterBox
                title="Account Name"
                items={accountNameList}
                search={search.accountName}
                setSearch={(val) => handleSearch("accountName", val)}
                selectedItems={filter.accountName}
                toggleItem={(item) => toggleItem("accountName", item)}
                selectAll={() => selectAll("accountName", accountNameList)}
              />
            </div>

          </Offcanvas.Body>
        </Offcanvas>

        {/* 🔷 Tables */}
        <Col xl={9} lg={8} >
          <Row className="g-2 mb-3">
            {["PARTYWISE", "ITEMWISE", "PARTY ITEMWISE"].map((btn) => (
              <Col xl={4} lg={4} md={4} sm={12} xs={12} key={btn}>
                <button
                  onClick={() => setActiveTable(btn)}
                  style={{
                    width: "100%",
                    height: "58px",
                    borderRadius: "14px",
                    cursor: "pointer",
                    fontWeight: "600",
                    border: `2px solid ${isdark === "light"
                      ? iscolour?.Colour6
                      : iscolourDark?.Colour7
                      }`,
                    background:
                      activeTable === btn
                        ? isdark === "light"
                          ? iscolour?.Colour6
                          : iscolourDark?.Colour7
                        : isdark === "light"
                          ? iscolour?.Colour1
                          : iscolourDark?.Colour4,
                    color:
                      activeTable === btn
                        ? isdark === "light"
                          ? iscolour?.Colour1
                          : iscolourDark?.Colour1
                        : isdark === "light"
                          ? "#000"
                          : "#fff",
                  }}
                >
                  {btn}
                </button>
              </Col>
            ))}
          </Row>
          <div
            style={{
              borderRadius: "14px",
              overflow: "hidden",
              marginTop: "10px",
              boxShadow: "0 4px 10px rgba(0,0,0,0.2)",
            }}
          >
            {/* 🔹 Heading */}
            <div
              style={{
                padding: "14px",
                background:
                  isdark === "light"
                    ? iscolour?.Colour6
                    : iscolourDark?.Colour7,
                color: "#fff",
                fontWeight: "600",
              }}
            >
              {activeTable}
            </div>

            {/* 🔹 Table */}
            {activeTable === "ITEMWISE" && (
              <ColourTable columns={TableChartColumns} data={TableChartRow} />
            )}

            {activeTable === "PARTYWISE" && (
              <ColourTable columns={TableChartColumns1} data={TableChartRow1} />
            )}

            {activeTable === "PARTY ITEMWISE" && (
              <ColourParentChild
                data={rows}
                columns={columns}
                parentKey="ItemName"
              />
            )}
          </div>
        </Col>
      </Row>
      {showDatePicker && (
        <div
          style={{
            position: "fixed",
            inset: 0,
            background: "rgba(0,0,0,0.5)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 99999,
          }}
          onClick={() => setShowDatePicker(false)}
        >
          <ColorCalenderCss
            isdark={isdark}
            iscolour={iscolour}
            iscolourDark={iscolourDark}
          />
          <div
            style={{
              background:
                isdark === "light" ? iscolour?.Colour3 : iscolourDark?.Colour3,

              borderRadius: "20px",
            }}
            onClick={(e) => e.stopPropagation()}
          >
            <Calendar
              className="custom-calendar"
              selectRange={true}
              onChange={(value) => {
                if (Array.isArray(value)) {
                  setDateRange([
                    {
                      startDate: value[0],
                      endDate: value[1],
                      key: "selection",
                    },
                  ]);
                }
              }}
              value={
                dateRange?.[0]?.startDate && dateRange?.[0]?.endDate
                  ? [dateRange[0].startDate, dateRange[0].endDate]
                  : null
              }
            />

            <div
              className="date-picker-footer"
              style={{
                textAlign: "center",
                marginTop: "15px",
                padding: "12px",
                background:
                  isdark === "light"
                    ? iscolour?.Colour3
                    : iscolourDark?.Colour3,
                borderRadius: "0 0 20px 20px",
              }}
            >
              <button
                onClick={() => setShowDatePicker(false)}
                style={{
                  padding: "10px",
                  borderRadius: "12px",
                  border: "none",
                  cursor: "pointer",
                  fontWeight: "700",
                  color: "#fff",
                  background:
                    isdark === "light"
                      ? iscolour?.Colour7
                      : iscolourDark?.Colour7,
                  boxShadow: "0 4px 10px rgba(0,0,0,0.25)",
                  transition: "0.2s ease",
                }}
                onMouseEnter={(e) => {
                  e.target.style.opacity = "0.85";
                  e.target.style.transform = "scale(1.05)";
                }}
                onMouseLeave={(e) => {
                  e.target.style.opacity = "1";
                  e.target.style.transform = "scale(1)";
                }}
              >
                Done
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Party_ItemAnalysis;
